// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import menuReducer from './slices/menuSlice';
import itemReducer from './slices/itemSlice';
import cartReducer from './slices/cartSlice';
import authReducer from "./slices/authSlice";
import comboReducer from './slices/comboSlice'; 
const store = configureStore({
  reducer: {
    menu: menuReducer,
    item: itemReducer,
    cart: cartReducer,
    auth: authReducer,
    combo: comboReducer,
  },
});

export default store;
